import React from 'react';
import PropTypes from 'prop-types';
import { View, Input } from 'modules/styled/web';
import { LinkFont, SecondaryText } from 'modules/styled';

const FormField = (props) => {
  const { error, type, placeholder, label, value, onChange, onBlur, onFocus, onKeyDown } =
    props;
  return (
    <View sx={{ mt: 3 }}>
      <label>
        <LinkFont sx={{ color: 'black' }}>{label}</LinkFont>
      </label>
      <Input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
      />
      {error ? <SecondaryText sx={{ mt: 1, color: 'red' }}>{error}</SecondaryText> : null}
    </View>
  );
};

FormField.propTypes = {
  error: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
};

export default FormField;
